import { LS, SS } from './libStorage'
const illegalValue = ['', null, 'undefined', undefined, 'null']

export const developerRegion = '@@iap_developer_region'

function filterValue(val) {
  return illegalValue.includes(val) ? '' : val
}

const originSetEvent = SS.set
SS.set = function (key, val) {
  const value = filterValue(val)
  return originSetEvent.call(SS, key, value)
}

const originGetEvent = SS.get
SS.get = function (key) {
  const value = originGetEvent.call(SS, key)
  return filterValue(value || '')
}

export const storage = LS
export const session = SS
